export default "__VITE_PUBLIC_ASSET__9e77eaa0__"